import React from 'react';

import {CircularProgress, Stack} from "@mui/joy";

// components
import BaseApi from "../../utils/BaseApi";
import LetterCreateModal from "./LetterCreateModal";
import CommonPaginatedComponentList from "../Common/CommonPaginatedComponentList";
import LetterCard from "./LetterCard";
import Typography from "@mui/joy/Typography";


class LetterTab extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            letters: null,
            pages: null,
        };
    }

    async componentDidMount() {
        await this.retrieveLetters();
    }

    async componentDidUpdate(prevProps, prevState, snapshot){
        if (prevProps !== this.props){
            await this.retrieveLetters();
        }
    }

    async retrieveLetters() {
        const url = 'letter/';
        const api = new BaseApi();
        let params = {
            account: this.props.account?.id,
            opportunity: this.props.opportunity?.id,
            lead: this.props.lead?.id,
            page_size: 10000,
        }
        let response = await api.get(url, params);
        this.setState(
            {
                letters: response.data.results,
            }
        );
    }

    render() {
        if (!this.props.account) {
            return (
                <Typography>
                    В связанной сущности должно быть заполнено поле "Компания"
                </Typography>
            )
        }
        if (!this.state.letters) {
            return (<CircularProgress/>)
        }
        return (
            <Stack
                spacing={2}
            >
                <LetterCreateModal
                    opportunity={this.props.opportunity}
                    account={this.props.account}
                    contact={this.props.contact}
                    lead={this.props.lead}
                    callBack={this.retrieveLetters.bind(this)}
                />
                <CommonPaginatedComponentList
                    title={''}
                    component={LetterCard}
                    componentKeyword={'letter'}
                    data={this.state.letters}
                    callBack={this.retrieveLetters.bind(this)}
                />
            </Stack>
        )
    }
}

export default LetterTab
